import { FunctionComponent } from "react";

interface IProps {
  stroke?: string;
  width?: string;
  height?: string;
}

const ShoppingTrolley: FunctionComponent<IProps> = ({ width = "24", height = "24" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 20.5C11.8284 20.5 12.5 19.8284 12.5 19C12.5 18.1716 11.8284 17.5 11 17.5C10.1716 17.5 9.5 18.1716 9.5 19C9.5 19.8284 10.1716 20.5 11 20.5Z"
      stroke="#111111"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M17 20.5C17.8284 20.5 18.5 19.8284 18.5 19C18.5 18.1716 17.8284 17.5 17 17.5C16.1716 17.5 15.5 18.1716 15.5 19C15.5 19.8284 16.1716 20.5 17 20.5Z"
      stroke="#111111"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M2.5 3.5H5.75L9.375 14.5H18.625L21.5 5.5H6.46875"
      stroke="#111111"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShoppingTrolley;
